export default "__VITE_ASSET__DSXsfHOO__"